<section
  class="visibility"
  [formGroup]="fieldForm"
  *ngIf="currentDataFields && currentDataFields.length > 0 && chartType"
>
  <span class="sectionHeader">VISIBLE COLUMNS* </span>
  <div class="fieldArea">
    <div class="group-list">
      <div>
        <div class="reportField-box">
          <div class="canvasFields">
            <div class="right">
              <mat-form-field appearance="fill" style="width: 100%">
                <mat-select
                  [multiple]="true"
                  formControlName="fields"
                  placeholder="Data Field"
                  floatPlaceholder="never"
                  (selectionChange)="buildAggregateData($event)"
                >
                  <ng-container *ngIf="chartType">
                    <mat-option
                      *ngFor="let item of currentDataFields"
                      [value]="item.id"
                    >
                      {{ item.name }}
                    </mat-option>
                  </ng-container>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="far-right"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
